<template>
    <el-row>
        <el-col :span="leftSpan">
            <div
                    style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 400px"
            >
                <h3>請選擇月份</h3>
                <el-select v-model="month" size="large">
                    <el-option
                            v-for="m in months"
                            :key="m.id"
                            :value="m.month"
                            :label="m.month"></el-option>
                </el-select>
                <h3>請選擇場地</h3>
                <el-select v-model="roomId" size="large">
                    <el-option
                            v-for="room in drawableRooms"
                            :key="room.id"
                            :value="room.id"
                            :label="room.label"
                    ></el-option>
                </el-select>
                <div style="margin-top: 10px;">

                    <el-button @click="draw" type="primary">試抽</el-button>
                    <el-button @click="onCommit" type="danger"
                               v-if="showResult"
                               :disabled="resultRoomIds.length <= 0"
                    >套用此結果
                    </el-button>
                </div>
            </div>
        </el-col>
        <el-col v-if="showResult" :span="12">
            <el-tabs
                    v-model="active"
            >
                <el-tab-pane
                        v-for="t in roomTabs"
                        :key="t.value"
                        :label="t.label"
                        :name="t.value"
                >
                    <h3>依照抽中順序排列</h3>
                    所有可用時段數:{{statistic[t.value].total}},
                    保留數:{{statistic[t.value].reserved}},
                    可抽籤數:{{statistic[t.value].available}},
                    實際中籤數:{{statistic[t.value].real}}
                    <br/>
                    小計: {{summary}}
                    <el-table
                            :data="getDrewResultsOf(roomId)"
                    >
                        <el-table-column
                                width="100"
                                prop="date"
                                label="日期"
                        ></el-table-column>
                        <el-table-column
                                prop="results"
                                label="結果"
                        ></el-table-column>
                    </el-table>

                </el-tab-pane>
            </el-tabs>
        </el-col>
    </el-row>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import moment from 'moment';
    import {join} from '../../utilities';

    export default {
        name: 'ManualDraw',
        data: () => ({
            roomId: '',
            month: new Date().getMonth() + 1,
            showResult: false,
            active: '',
        }),
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState('setting', ['rooms', 'months', 'ncutRooms']),
            ...mapState('manage', ['drewResults', 'statistic']),

            drawableRooms() {
                const drawableNcutRoomIds = new Set(this.rooms.filter(r => r.drawable)
                    .map(r => r.ncutRoomId));
                const drewRoomIds = (this.selectedMonth || {}).drewRoomIds || [];
                return this.ncutRooms.filter(r => drawableNcutRoomIds.has(r.id))
                    .map(r => (
                        {
                            ...r,
                            label: drewRoomIds.some(d => d === r.id) ? `${r.name}(已抽)` : r.name
                        }
                    ));
            },
            isAllDrew() {
                return this.drawableRooms.filter(r => r.isDrew).length === this.drawableRooms.length;
            },
            selectedMonth() {
                return this.months.find(m => m.month === this.month);
            },
            leftSpan() {
                return this.showResult ? 12 : 24;
            },
            resultRoomIds() {
                return (Object.keys(this.drewResults) || []).filter(r => this.roomId === r);
            },
            summary() {
                const drewResultsOf = this.drewResults[this.roomId] || {};
                const distributed =  Object.keys(drewResultsOf).reduce((s, key) => [...s, ...drewResultsOf[key]], [])
                    .reduce((s, r) => {
                        (s[r.applicant.shortDepartmentName] = s[r.applicant.shortDepartmentName] || [])
                            .push(r)
                        return s;
                    },{})
                    ;
                return Object.keys(distributed)
                    .map(d => `${d}:${distributed[d].length}`)
                    .join(', ');
            },
            roomTabs() {
                return join([this.roomId], this.ncutRooms, l => l, r => r.id, (l, r) => ({
                    label: r.name,
                    value: l
                }));
            }
        },
        watch: {
            roomTabs(current) {
                if (current.length > 0) {
                    this.active = current[0].value;
                }
            },
            drawableRooms(current) {
                if (current && current[0]) {
                    this.roomId = current[0].id;
                }
            },
            resultRoomIds(current) {
                this.showResult = !!(current && current.length > 0);
            }
        },
        methods: {
            ...mapActions('setting', {
                getNcutRooms: 'getNcutRoomsAction',
                getMonths: 'getMonthsAction',
            }),
            ...mapActions('manage', {
                tryDraw: 'tryDrawAction',
                commitDraw: 'commitDrawAction'
            }),
            async draw() {
                const {roomId, month, seed} = this;
                //this.showResult = true;
                await this.tryDraw({
                    roomId,
                    month,
                    seed
                });
            },
            show() {
                const num = this.resultRoomIds.length;
                if (num <= 0) {
                    this.$message({
                        message: '請至少按一次試抽',
                        type: 'warning'
                    })
                } else {
                    this.showResult = true;
                }
            },

            getDrewResultsOf(roomId) {
                const drewResultsOf = this.drewResults[roomId] || {};
                return Object.keys(drewResultsOf)
                    .map(k => ({
                        date: k,
                        results: drewResultsOf[k].map((r) => `
                        ${r.tag}_${r.roomName}_${r.applicant.name}(${r.applicant.shortDepartmentName})`
                        ).join(', ')
                    }))
            },
            async onCommit() {
                try {
                    await this.$confirm('確定要套用嗎?，將會覆蓋現有的抽籤結果!', {
                        type: 'warning',
                    });
                    const {month, roomId} = this;
                    const success = await this.commitDraw({
                        roomId,
                        month,
                    });
                    if (success) {
                        await this.getMonths();
                        this.$message.success('套用成功');
                    } else {
                        this.$message.error('套用失敗，請重試!');
                    }
                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                        this.show = false;
                    }
                }
            }
        },
        async created() {
            await this.getNcutRooms();

        }
    }
</script>

<style scoped>

</style>